import { TFunction } from "i18next";

export enum ApiOrganizationListType {
  termination_leave_types = "termination_leave_types",
  termination_reasons = "termination_reasons",
  job_catalog_tracks = "job_catalog_tracks",
  job_catalog_grades = "job_catalog_grades",
  employee_position_change_reasons = "employee_position_change_reasons",
}

export interface ApiOrganizationListItem {
  id: number;
  title: string;
  sort: number;
  is_archived: boolean;
}

export interface ApiOrganizationListShort {
  id: number;
  title: string;
  type: ApiOrganizationListType;
}

export interface ApiOrganizationList {
  id: number;
  title: string;
  type: ApiOrganizationListType;
  items: ApiOrganizationListItem[];
}

export interface ApiOrganizationListItemPayload {
  id?: number | null;
  title: string;
}

export interface ApiOrganizationListUpdatePayload {
  title?: string | null;
  items?: ApiOrganizationListItemPayload[] | null;
}

export function getOrganizationListTypeTitle(type: ApiOrganizationListType, t: TFunction): string {
  switch (type) {
    case ApiOrganizationListType.termination_leave_types:
      return t("core:termination_leave_types");
    case ApiOrganizationListType.termination_reasons:
      return t("core:termination_reasons");
    case ApiOrganizationListType.job_catalog_tracks:
      return t("core:job_catalog_tracks");
    case ApiOrganizationListType.job_catalog_grades:
      return t("core:job_catalog_grades");
    case ApiOrganizationListType.employee_position_change_reasons:
      return t("core:employee_position_change_reasons");
    default:
      return type;
  }
}
